import styled from 'styled-components';
import { colors, layout, media } from '@prisjakt/ui-base';
import CloseIconBase from 'mdi-react/CloseIcon';

export const OptionList = styled.ul`
  list-style: none;
  margin: ${layout.spacing.xSmall} 0 0 0;
`;

export const ShowMoreButton = styled.button``;

export const LoaderWrapper = styled.div`
  display: flex;
  width: 100%;
  height: 40px;
  justify-content: center;
`;

export const SearchInputWrapper = styled.div`
  position: relative;
  margin: ${layout.spacing.small};
  margin-bottom: ${layout.spacing.xSmall};

  ${media.mediumDown`
    margin: ${layout.spacing.xSmall};
  `}
`;

export const SearchInput = styled.input`
  width: 100%;
  padding: ${layout.spacing.xSmall} ${layout.spacing.small};
  outline: 0;
  border-radius: 4px;
  border: 1px solid ${p => p.theme.lines.tertiary};

  &:focus {
    border-color: ${p => p.theme.lines.highlight};
  }
`;

export const ClearButton = styled.button`
  align-items: center;
  cursor: pointer;
  display: flex;
  height: 100%;
  padding: ${layout.spacing.xSmall};
  position: absolute;
  right: 0;
  top: 0;
`;

export const ClearIcon = styled(CloseIconBase).attrs(p => ({
  color: p.theme.icons.tertiary,
}))``;

export const SelectedFiltersWrapper = styled.div`
  ${OptionList} {
    background: ${colors.semiWhite};
    padding: ${layout.spacing.xSmall} 0;
  }
`;
